import * as React from 'react';
import { Dispatch } from 'react-redux';
import { StoreState } from '../../reducers';
import { Api } from '../../typings/api';
import { DriveItemListDisplayType } from '../../containers/DriveItemList/constants';
import DriveItemInfoButton from '../../containers/DriveItem/InfoButton';
import DriveItemFavoriteIcon from '../../containers/Favorites/favoriteIcon';
import { OfflineManagerState } from '../../containers/OfflineManager/reducer';
import Utils from '../../utils';
import DriveItemUtils, { ResolutionDisplayType } from '../../utils/driveItem';
import { ImageWrapperVariants, SvgWrapper, Image, BackgroundImage, Footer, LabelVariants, InnerDriveItemBlock } from '../../containers/DriveItem/styles';

interface DriveItemBlockProps {
	dispatch: Dispatch<StoreState>;
	driveItem: Api.DriveItem;
	displayType: DriveItemListDisplayType;
	resolutions: { [k: string]: Api.ResolutionGroup };
	galleryConfig: Api.Config;
	offlineManager: OfflineManagerState;
}

const DriveItemBlock = (props: DriveItemBlockProps) => {

	const getImgElement = () => {
		const { driveItem, displayType, offlineManager, galleryConfig, resolutions, dispatch } = props;
		const thumbnailIsBox = displayType === DriveItemListDisplayType.Masonry;
		const thumbnailDescriptor = DriveItemUtils.getThumbnailDescriptor(driveItem, thumbnailIsBox, offlineManager, galleryConfig, resolutions, dispatch);
		const { isImage, src } = thumbnailDescriptor;
		const favElement = (
						<DriveItemFavoriteIcon
							itemId={driveItem.id}
							displayMode={ResolutionDisplayType.Card}
							needBottomPadding={isImage && displayType === DriveItemListDisplayType.Masonry}
						/>);
		if (isImage) {
			const ImageWrapper = ImageWrapperVariants[displayType];
			const ImageComponent = displayType === DriveItemListDisplayType.Grid ? BackgroundImage : Image;
			return <ImageWrapper><ImageComponent src={src} />{favElement}</ImageWrapper>;
		} else {
			return <SvgWrapper>{Utils.getSvgIcon(src)}{favElement}</SvgWrapper>;
		}
	};

	const { driveItem, displayType } = props;
	const label = DriveItemUtils.getLabel(driveItem);
	const Label = LabelVariants[displayType];
	const imgElement = getImgElement();

	return (
		<InnerDriveItemBlock>
			{imgElement}
			<Footer>
				<Label>{label}</Label>
				<DriveItemInfoButton driveItem={driveItem} />
			</Footer>
		</InnerDriveItemBlock>
	);
};

export default DriveItemBlock;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DriveItem/Block.tsx